import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { Box, Typography } from '@applyboard/ui-components';
import QuestionIcon from "./QuestionIcon";
import { QUESTION_DISPLAY_NAMES, QUESTION_FORMATS } from "./consts";
import { OrderedList } from "./style";
var QuestionDetails = function QuestionDetails(_ref) {
  var questionFormat = _ref.questionFormat,
    answerOptions = _ref.answerOptions;
  if (!(questionFormat === QUESTION_FORMATS.checkbox || questionFormat === QUESTION_FORMATS.dropdown)) {
    return /*#__PURE__*/React.createElement(Box, {
      component: "dd",
      display: "flex",
      alignItems: "center",
      mb: 1
    }, /*#__PURE__*/React.createElement(QuestionIcon, {
      questionFormat: questionFormat
    }), /*#__PURE__*/React.createElement(Typography, {
      ml: 1,
      variant: "paragraph"
    }, QUESTION_DISPLAY_NAMES[questionFormat]));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, answerOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement(Box, {
      key: index,
      component: "dd",
      display: "flex",
      alignItems: "center",
      mb: 1
    }, /*#__PURE__*/React.createElement(QuestionIcon, {
      questionFormat: questionFormat
    }), /*#__PURE__*/React.createElement(Typography, {
      ml: 1,
      variant: "paragraph"
    }, option));
  }));
};
var Questions = function Questions(_ref2) {
  var questionsDifferences = _ref2.questionsDifferences;
  return /*#__PURE__*/React.createElement(OrderedList, null, questionsDifferences.map(function (questionDifference, index) {
    var question = questionDifference.question,
      questionFormat = questionDifference.questionFormat,
      answerOptions = questionDifference.answerOptions;
    if (!(questionFormat in QUESTION_DISPLAY_NAMES)) return null;
    return /*#__PURE__*/React.createElement(Box, {
      key: index,
      component: "li",
      mb: 4
    }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement(Box, {
      component: "dt",
      mb: 2
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph"
    }, "".concat(index + 1, ". ").concat(question))), /*#__PURE__*/React.createElement(QuestionDetails, {
      questionFormat: questionFormat,
      answerOptions: answerOptions
    })));
  }));
};
export default Questions;